import { render, staticRenderFns } from "./CustomUploadField.vue?vue&type=template&id=4a1381ad"
import script from "./CustomUploadField.vue?vue&type=script&lang=js"
export * from "./CustomUploadField.vue?vue&type=script&lang=js"
import style0 from "./CustomUploadField.vue?vue&type=style&index=0&id=4a1381ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports